import { PrinterAdapter } from '@/features/print/adapters/types'
import { ErrorCode } from '@/features/print/constants'
import { PrinterError } from '@/features/print/errors'
import { NetworkConnectionOptions } from '@/features/print/types'
import TcpSocket from 'react-native-tcp-socket'

const DEFAULT_PORT = 9100
const CONNECTION_TIMEOUT = 10000

export class NetworkPrinterAdapter implements PrinterAdapter {
    constructor(private options: NetworkConnectionOptions) {}

    async print(data: Buffer): Promise<void> {
        return new Promise<void>((resolve, reject) => {
            const client = TcpSocket.createConnection(
                { host: this.options.ipAddress, port: DEFAULT_PORT },
                () => {
                    client.write(data, 'utf8', () => {
                        client.end()
                        resolve()
                    })
                }
            )

            client.setTimeout(CONNECTION_TIMEOUT)

            client.on('error', (error) => {
                client.destroy()
                reject(
                    new PrinterError(
                        ErrorCode.NetworkError,
                        { ip: this.options.ipAddress, message: error.message },
                        error
                    )
                )
            })

            client.on('timeout', () => {
                client.destroy()
                reject(
                    new PrinterError(ErrorCode.NetworkTimeout, {
                        ip: this.options.ipAddress,
                        timeout: CONNECTION_TIMEOUT,
                    })
                )
            })
        })
    }
}
